(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mateevs-ugc-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.mateevs-ugc-reviews');
    if (!section) return;

    const track = section.querySelector('[data-ugc-track]');
    const prev = section.querySelector('[data-ugc-prev]');
    const next = section.querySelector('[data-ugc-next]');
    const dots = section.querySelector('[data-ugc-dots]');
    if (!track || !prev || !next || !dots) return;

    const cards = [...track.querySelectorAll('.mateevs-ugc-reviews__video-card')];
    if (!cards.length) return;

    const getStep = () => {
      const first = cards[0];
      if (!first) return 0;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return first.getBoundingClientRect().width + gap;
    };

    const getIndex = () => {
      const step = getStep();
      return step ? Math.round(track.scrollLeft / step) : 0;
    };

    const renderDots = () => {
      dots.innerHTML = '';
      const visible = window.matchMedia('(min-width: 750px)').matches ? 4 : 1;
      const pages = Math.max(1, cards.length - visible + 1);
      for (let i = 0; i < pages; i += 1) {
        const dot = document.createElement('span');
        dot.className = 'mateevs-ugc-reviews__dot';
        dots.append(dot);
      }
      update();
    };

    const update = () => {
      const dotsEls = [...dots.children];
      const index = Math.min(getIndex(), Math.max(0, dotsEls.length - 1));
      dotsEls.forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
      const maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.toggleAttribute('disabled', track.scrollLeft <= 1);
      next.toggleAttribute('disabled', track.scrollLeft >= maxScroll);
    };

    const scrollByCard = (direction) => {
      track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByCard(-1));
    next.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', renderDots, { passive: true });

    renderDots();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mateevs-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initUGC = (root) => {
    if (!root || root.dataset.ugcInitialized === 'true') return;
    root.dataset.ugcInitialized = 'true';

    const track = root.querySelector('[data-track]');
    const prev = root.querySelector('[data-prev]');
    const next = root.querySelector('[data-next]');
    const dots = root.querySelector('[data-dots]');
    const cards = [...root.querySelectorAll('.mateevs-ugc__card')];
    if (!track || !cards.length) return;

    const videos = [...root.querySelectorAll('.mateevs-ugc__media video')];

    const resetVideo = (video) => {
      if (!video) return;
      video.pause();
      try { video.currentTime = 0; } catch (error) {}
      const media = video.closest('.mateevs-ugc__media');
      media?.classList.remove('is-playing');
    };

    const playOnly = (video) => {
      if (!video) return;

      if (!video.paused) {
        resetVideo(video);
        return;
      }

      videos.forEach((other) => {
        if (other !== video) resetVideo(other);
      });

      const media = video.closest('.mateevs-ugc__media');
      media?.classList.add('is-playing');

      const start = () => {
        video.currentTime = 0;
        video.play().catch(() => resetVideo(video));
      };

      if (video.readyState >= 2) {
        start();
      } else {
        video.addEventListener('canplay', start, {once: true});
        video.load();
      }
    };

    root.querySelectorAll('.mateevs-ugc__media').forEach((media) => {
      const video = media.querySelector('video');
      const playButton = media.querySelector('[data-play]');
      if (!video) return;

      const handlePlay = (event) => {
        event.preventDefault();
        event.stopPropagation();
        playOnly(video);
      };

      playButton?.addEventListener('click', handlePlay);
      media.addEventListener('click', (event) => {
        if (event.target.closest('button')) return;
        playOnly(video);
      });

      video.addEventListener('ended', () => resetVideo(video));
    });

    const getStep = () => {
      const first = cards[0];
      const gap = parseFloat(getComputedStyle(track).gap || '16');
      return first.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      dots.style.display = mobile && cards.length > 1 ? 'flex' : 'none';
      const index = Math.min(Math.round(track.scrollLeft / Math.max(getStep(), 1)), cards.length - 1);
      [...dots.children].forEach((dot, i) => dot.toggleAttribute('data-active', i === index));
    };

    const buildDots = () => {
      dots.innerHTML = '';
      cards.forEach(() => dots.appendChild(document.createElement('span')));
      update();
    };

    prev.addEventListener('click', () => track.scrollBy({left: -getStep(), behavior: 'smooth'}));
    next.addEventListener('click', () => track.scrollBy({left: getStep(), behavior: 'smooth'}));
    track.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', buildDots, {passive: true});
    buildDots();
  };

  const boot = () => document.querySelectorAll('[data-ugc-section]').forEach(initUGC);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, {once: true});
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('[data-ugc-section]') || event.target?.closest?.('[data-ugc-section]');
    if (root) initUGC(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
